import Breadcrumb from "components/Common/Breadcrumb"
import Loader from "components/Loader/Loader"
import React, { useEffect, useState } from "react"
import { Button, Card, CardBody, Col, Input, Label, Row } from "reactstrap"
import Swal from "sweetalert2"
import { fetchData, FetchPutData } from "utils/Common_api_functions"
import { useNavigate } from "react-router-dom"
import { MdCancel } from "react-icons/md"
import { FaSave } from "react-icons/fa"
import image from "../../assets/images/allowance.jpg"

const allowOnlyNumbers = value => {
  // Remove anything except digits and dot
  let sanitized = value.replace(/[^0-9.]/g, "")

  // Allow only ONE decimal point
  const parts = sanitized.split(".")
  if (parts.length > 2) {
    sanitized = parts[0] + "." + parts.slice(1).join("")
  }

  // Limit to 2 digits after decimal
  if (parts.length === 2) {
    sanitized = parts[0] + "." + parts[1].slice(0, 2)
  }

  return sanitized
}

const Allowance = () => {
  const [loading, setLoading] = useState(false)
  const [travelAllowance, setTravelAllowance] = useState("")
  const [dearnessAllowance, setDearnessAllowance] = useState("")
  const [errors, setErrors] = useState({})

  const Navigate = useNavigate()

  /* 🔹 Fetch existing allowance (optional but recommended) */
  useEffect(() => {
    fetchAllowance()
  }, [])

  const fetchAllowance = async () => {
    const APIdata = await fetchData(setLoading, "allowance")
    if (APIdata?.success) {
      setTravelAllowance(APIdata.data?.[0].ta || "")
      setDearnessAllowance(APIdata.data?.[0]?.da || "")
    }
  }

  /* 🔹 Validation */
  const validate = () => {
    const newErrors = {}

    if (!travelAllowance) {
      newErrors.travelAllowance = "Travel allowance is required"
    }

    if (!dearnessAllowance) {
      newErrors.dearnessAllowance = "Dearness allowance is required"
    }

    if (Number(travelAllowance) < 0) {
      newErrors.travelAllowance = "Value cannot be negative"
    }

    if (Number(dearnessAllowance) < 0) {
      newErrors.dearnessAllowance = "Value cannot be negative"
    }

    setErrors(newErrors)
    return Object.keys(newErrors).length === 0
  }

  /* 🔹 Save / Update */
  const handleSave = async () => {
    if (!validate()) return

    const APIdata = await FetchPutData(setLoading, "allowance", 1, {
      ta: travelAllowance,
      da: dearnessAllowance,
    })
    if (APIdata?.data?.success) {
      Swal.fire({
        title: "Allowances Updated Successfully.",
        text: APIdata?.data?.message,
        icon: "success",
      })
      fetchAllowance()
    } else {
      Swal.fire({
        title: "Something went Wrong.",
        text: APIdata?.response?.data?.message,
        icon: "error",
      })
    }
  }

  return (
    <div className="page-content">
      {loading && <Loader />}
      <Breadcrumb title="Settings" breadcrumbItem="Allowances" />

      <Card className="mb-3">
        <CardBody>
          <Row>
            <Col xl={6} className="text-center">
              <img
                src={image}
                alt="Allowances"
                className="img-fluid mb-3"
                style={{ maxHeight: "320px" }}
              />

              <p className="text-muted px-4">
                Manage travel and dearness allowances used for employee expense
                calculation and payroll processing.
              </p>
            </Col>

            <Col xl={6}>
              <h4 className="mb-4 fw-bold">Allowances</h4>

              <Row className="mb-3">
                {/* Travel Allowance */}
                <Col xl={12}>
                  <Label>
                    Travel Allowance Per Kilometer{" "}
                    <span className="text-danger">*</span>
                  </Label>
                  <Input
                    type="text"
                    value={travelAllowance}
                    onChange={e =>
                      setTravelAllowance(allowOnlyNumbers(e.target.value))
                    }
                    className={`rounded-4 ${
                      errors.travelAllowance ? "is-invalid" : ""
                    }`}
                  />
                  {errors.travelAllowance && (
                    <div className="invalid-feedback d-block">
                      {errors.travelAllowance}
                    </div>
                  )}
                </Col>
              </Row>

              <Row className="mb-4">
                {/* Dearness Allowance */}
                <Col xl={12}>
                  <Label>
                    Dearness Allowance <span className="text-danger">*</span>
                  </Label>
                  <Input
                    type="text"
                    value={dearnessAllowance}
                    onChange={e =>
                      setDearnessAllowance(allowOnlyNumbers(e.target.value))
                    }
                    className={`rounded-4 ${
                      errors.dearnessAllowance ? "is-invalid" : ""
                    }`}
                  />
                  {errors.dearnessAllowance && (
                    <div className="invalid-feedback d-block">
                      {errors.dearnessAllowance}
                    </div>
                  )}
                </Col>
              </Row>

              <Button color="primary" onClick={handleSave}>
                <FaSave /> Save
              </Button>
              <Button
                color="secondary"
                className="ms-2"
                onClick={() => Navigate(-1)}
              >
                <MdCancel /> Cancel
              </Button>
            </Col>
          </Row>
        </CardBody>
      </Card>
    </div>
  )
}

export default Allowance
